module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 102
// module chunks = 0